import { RequestCharge } from "@app/core";

export class FMDeliveryRequestModel {
  id: string;
  requestStatusName: string;
  requestStatusId: number;
  requestId: number;
  requestNumber: string;
  requestType: string;
  requestTypeId: number;
  companyName: string;
  requestorName: string;
  arrivalDate: Date;
  removalDate: Date;
  arrivalTime: string;
  removalTime: string;
  purposeSchedule :string ;
  otherTransportationMode : string;
  fmDeliveryLocationId: number;
  deliveryAdditionalRequirements: string;


  fmTransportationModeName :string ;
  userCanFeedback: boolean;
}




// WEBPACK FOOTER //
// ./src/app/core/models/fm-delivery-request.ts